"use client"
import BaseDetailsDrawer from "./BaseDetailsDrawer"
import { getJobsDetailController } from "../../../Controllers/BookingManagement"
import { __constants, __jobStatus, __snackBarSeverity, __snackBarText } from "../../../constants"
import moment from "moment"
import JobInvoice from "./JobInvoice"
import Button from "@mui/material/Button"
import Tags from "../../../common_components/Tags"
import Divider from "@mui/material/Divider"
import { useNavigate } from "react-router-dom"

const PostedJobDetails = ({ canvasState, setCanvasState }) => {
  const navigate = useNavigate()

  const config = {
    drawerTitle: "Job details",
    fetchDetails: getJobsDetailController,
    getId: (canvasState) => canvasState.jobId,
    InvoiceComponent: JobInvoice,
    snackBarSeverity: __snackBarSeverity,
    snackBarText: __snackBarText,

    getProfileData: (data) => ({
      profilePicture: `${__constants.images}${data?.jobDetails?.userId?.profilePicture || ""}`,
      name: `${data?.jobDetails?.userId?.firstName} ${data?.jobDetails?.userId?.lastName}`,
      reviews: {
        average: data?.userReviews?.average || 0,
        count: data?.userReviews?.count || 0,
      },
      about: data?.jobDetails?.userId?.aboutMe,
      children:
        data?.jobDetails?.jobPostedFor === "BabySitter"
          ? `${data?.jobDetails?.childrens?.length || 0} ${data?.jobDetails?.childrens?.length > 1 ? "Children" : "Child"}${
              data?.jobDetails?.childrens?.length > 0 && data?.jobDetails?.childrens[0].hasOwnProperty("dateOfBirth")
                ? ` - ${
                    data?.jobDetails?.childrens
                      ?.map((item) => moment(item?.dateOfBirth).toNow(true)?.split(" ")[0] || " ")
                      .join(", ")
                      .replace(
                        new RegExp(
                          `, ${
                            moment(data?.jobDetails?.childrens[data?.jobDetails?.childrens.length - 1]?.dateOfBirth)
                              .toNow(true)
                              ?.split(" ")[0]
                          }$`,
                        ),
                        ` & ${
                          moment(data?.jobDetails?.childrens[data?.jobDetails?.childrens.length - 1]?.dateOfBirth)
                            .toNow(true)
                            ?.split(" ")[0]
                        }`,
                      ) || ""
                  } year old`.replace("a year", "1 year")
                : ""
            }`
          : null,
    }),

    getRole: (data) => data?.jobDetails?.jobPostedFor,

    getAvailability: (data) => data?.jobDetails?.availability || [],

    getInvoiceId: (data) => data?.applicationId,

    getTagsSection: (data, themeClass) => (
      <Tags
        style={{ marginTop: "15px" }}
        title={
          data?.jobDetails?.jobPostedFor === "BabySitter" ? "Occasional babysitting on" : "Regular housekeeping on"
        }
        isActive={true}
      />
    ),

    getDetailsSection: (data, themeClass) => (
      <>
        <div style={{ display: "flex" }}>
          <strong className={themeClass}>Location</strong>
          <div>
            {data?.jobDetails?.jobAddress || " - "}, {data?.jobDetails?.jobArea || " - "},{" "}
            {data?.jobDetails?.jobCity || " - "}
          </div>
        </div>

        <Divider className="divider-gap" />

        <div style={{ display: "flex" }}>
          <strong className={themeClass}>Duration Type</strong>
          <div>{data?.jobDetails?.durationType || " - "}</div>
        </div>

        <Divider className="divider-gap" />

        {data?.jobDetails?.jobPostedFor === "HouseKeeper" && (
          <>
            <div style={{ display: "grid", rowGap: "0.5rem" }}>
              <strong className={themeClass}>Help with</strong>
              <div>
                {data?.jobDetails?.willingToHelpWith &&
                  data?.jobDetails?.willingToHelpWith.map((obj, index) => (
                    <Tags key={index} title={obj.name} isActive={true} />
                  ))}
                {data?.jobDetails?.willingToHelpWith &&
                  data?.jobDetails?.willingToHelpWith.length === 0 &&
                  "Data Not available"}
              </div>
            </div>
            <Divider className="divider-gap" />
            <div style={{ display: "grid", rowGap: "0.5rem" }}>
              <strong className={themeClass}>Cleaning type</strong>
              <div>
                {data?.jobDetails?.cleaningType?.name ? (
                  <>
                    {data?.jobDetails.cleaningType.name}
                    {data?.jobDetails.cleaningType.description && (
                      <div style={{ fontSize: "85%", opacity: 0.75 }}>{data?.jobDetails.cleaningType.description}</div>
                    )}
                  </>
                ) : "Not selected"}
              </div>
            </div>
            <Divider className="divider-gap" />
            <div style={{ display: "grid", rowGap: "0.5rem" }}>
              <strong className={themeClass}>Add-ons</strong>
              <div>
                {data?.jobDetails?.addOns?.length > 0
                  ? data?.jobDetails.addOns.map((obj, index) => <Tags key={index} title={obj.name} isActive={true} />)
                  : "Not selected"}
              </div>
            </div>
            <Divider className="divider-gap" />
          </>
        )}

        <div style={{ display: "grid", rowGap: "0.5rem" }}>
          <strong className={themeClass}>Preferred Languages</strong>
          {data?.jobDetails?.preferredLanguages?.length > 0
            ? data.jobDetails.preferredLanguages.join(", ")
            : "No preferred languages"}
        </div>

        <Divider className="divider-gap" />
        <div style={{ display: "grid", rowGap: "0.5rem" }}>
          <strong className={themeClass}>Job description</strong>
          {data?.jobDetails?.jobDescription || "Job description not available"}
        </div>

        {data?.jobDetails?.cancelledReason && (
          <>
            <Divider className="divider-gap" />
            <div style={{ display: "grid", rowGap: "0.5rem", fontSize: "0.875rem" }}>
              <strong className={themeClass} style={{ fontSize: "0.875rem" }}>
                Reason for cancelled by Customer
              </strong>
              <div>{data?.jobDetails?.cancelledReason}</div>
            </div>
          </>
        )}
      </>
    ),

    getActionButtons: (data, canvasState, handleInvoice) => (
      <>
        <div>
          <Button
            variant="contained"
            size="small"
            sx={{ mt: 3, textTransform: "unset" }}
            onClick={() => navigate(`appliers?id=${canvasState?.applicationId}`)}
          >
            View applicants
          </Button>
        </div>
        {[__jobStatus.finalized].includes(data?.jobDetails?.jobStatus) && (
          <div>
            <Button variant="contained" size="small" sx={{ mt: 3, textTransform: "unset" }} onClick={handleInvoice}>
              View invoice
            </Button>
          </div>
        )}
      </>
    ),
  }

  return <BaseDetailsDrawer canvasState={canvasState} setCanvasState={setCanvasState} config={config} />
}

export default PostedJobDetails
